import React from "react";
import Card from "react-bootstrap/Card";
import ChimneyIcon from "../assets/images/chimney-icon.png";
import AqiIcon from "../assets/images/aqi-icon.png";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div className="container my-5">
      <h4 className="text-center text-light display-6 mb-2 IRANSansXG">
        خدمات ما
      </h4>
      <div className="row">
        <div className="col-md-6">
          <Link to="/payesh" className="text-decoration-none">
            <Card
              bg="dark"
              style={{ width: "100%", border: "none" }}
              className="text-center text-light"
            >
              <Card.Img
                className="m-auto"
                style={{ width: 150, height: 150 }}
                variant="top"
                src={AqiIcon}
              />
              <Card.Body>
                <Card.Title>سامانه پایش هوای محیطی</Card.Title>
                <Card.Text>
                  در این سامانه شاخص کیفیت هوای اندازه گیری شده در نقاط مختلف
                  کشور نمایش داده می شود.
                </Card.Text>
              </Card.Body>
            </Card>
          </Link>
        </div>
        <div className="col-md-6">
          <Link to="/stacks" className="text-decoration-none">
            <Card
              bg="dark"
              style={{ width: "100%", border: "none" }}
              className="text-center text-light"
            >
              <Card.Img
                className="m-auto"
                style={{ width: 70, height: 150 }}
                variant="top"
                src={ChimneyIcon}
              />
              <Card.Body>
                <Card.Title>سامانه پایش دودکش های صنعتی</Card.Title>
                <Card.Text>
                  در این سامانه میزان ذرات خروجی دودکش ها و یا غلظت گاز های
                  خروجی (بسته به دستگاه اندازه گیری استفاده شده) در کارخانه های
                  طرف قرارداد ، نمایش داده می شود.
                </Card.Text>
              </Card.Body>
            </Card>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Services;
